import React from "react";
import { Marker } from "react-map-gl";
import { isDemoData } from "../boardData";
import { DEMO_PLACES } from "./demoBasemap";

// Town labels for the offline preview basemap (see demoBasemap.js). Renders
// nothing on a real board, where Mapbox's style carries its own labels.
export default function DemoPlaces() {
  if (!isDemoData()) return null;
  return DEMO_PLACES.map((p) => (
    // Sits just below the point, so the station marker at Riverside stays clear.
    <Marker key={p.name} latitude={p.lat} longitude={p.lng} anchor="top" offset={[0, 10]}>
      <span className={`sb-demo-place${p.major ? " major" : ""}`}>{p.name}</span>
    </Marker>
  ));
}
